import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';
import {LocalDataSource} from '../../../ng2-smart-table/lib/data-source/local/local.data-source';
import {NoteData} from '../../../interfaces/note';
import { AlertController } from '@ionic/angular';
import {Ng2SmartTableComponent} from '../../../ng2-smart-table/ng2-smart-table.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-page-note',
  templateUrl: 'note.html',
  styleUrls: ['./note.scss']
})
export class NotePageComponent implements OnInit {
  @Input() showHeader = true;
  @Input() smallView = false;
  @ViewChild('table') table: Ng2SmartTableComponent;

  formdata: any = new NoteData();
  notes: Array<Node> = [];
  tableData: LocalDataSource = new LocalDataSource();
  editRow: any = false;
  settings: any = {
    mode: 'external',
    add: {
      addButtonContent: 'Neu',
      inputClass: 'button button-md button-default button-default-md'
    },
    columns: {
      dateTime: {
        title: 'Datum',
        valuePrepareFunction: (date) => {
          return new DatePipe('de').transform(date, 'dd.MM.yyyy HH:mm:ss');
        }
      },
      desc: {
        title: 'Beschreibung'
      },
      editPerson: {
        title: 'Bearbeiter'
      }
    },
    actions: {
      columnTitle: '',
      add: true,
      edit: false,
      delete: true,
      custom: [],
      position: 'left', // left|right
    },
    delete: {
      deleteButtonContentIcon: 'trash',
      confirmDelete: true
    },
    filter: null,
    pager: {
      display: true,
      perPage: 5
    },
    hideSubHeader: false,
    noDataMessage: 'kein Notizen vorhanden'
  };

  constructor(public patientDataProvider: PatientDataProvider, private alertController: AlertController) {
  }

  async ngOnInit() {
    if (!this.patientDataProvider.activePatientData.notes) {
      this.patientDataProvider.activePatientData.notes = [];
    }

    const actDate = parseInt(new DatePipe('de').transform(new Date(), "HHmm"));

    const findIdx = this.patientDataProvider.activePatientData.notes.findIndex((el) => {

      if(el.from && el.to) {
        if(actDate >= parseInt(el.from) &&  actDate <= parseInt(el.to)) {
          return true;
        }
      }

    });

    await this.tableData.load(this.patientDataProvider.activePatientData.notes);

    if(findIdx !== -1) {
      setTimeout(() => {
        this.table.grid.selectRow(this.table.grid.getRows()[findIdx]);
      }, 500);
    
     this.rowSelect({data:this.patientDataProvider.activePatientData.notes[findIdx]});
    }       
  }

  rowSelect(data) {
    const idx = this.patientDataProvider.activePatientData.notes.indexOf(data.data);
    if (idx !== -1) {
      this.editRow = idx;
    }

    if(data.data.from) {
      const _from = data.data.from;
      if(typeof _from === 'string' && _from.length === 4) {
        data.data.from = _from.substring(0,2) + ':' + _from.substring(2);
      }
    }

    if(data.data.to) {
      const _to = data.data.to;
      if(typeof _to === 'string' && _to.length === 4) {
        data.data.to = _to.substring(0,2) + ':' + _to.substring(2);
        
      }
    }
    
    this.formdata = data.data;
  }

  newNote() {
    this.formdata = new NoteData();
    this.editRow = false;
  }

  async saveNode(form: NgForm) {
    if (form.valid) {

      this.formdata.dateTime = new Date().getTime();
      this.formdata.editPerson = this.patientDataProvider.api._user.profile.firstname + ' ' + this.patientDataProvider.api._user.profile.lastname;

      if(this.formdata.from && this.formdata.from.length === 5) {
        this.formdata.from = this.formdata.from.replace(':', '');
      }

      if(this.formdata.to && this.formdata.to.length === 5) {
        this.formdata.to = this.formdata.to.replace(':', '');
      }


      if (this.editRow === false) {
        this.patientDataProvider.activePatientData.notes.push(this.formdata);
      } else {
        this.patientDataProvider.activePatientData.notes[this.editRow] = this.formdata;
      }

      this.tableData.refresh();

      const res:any = await firstValueFrom(this.patientDataProvider.update(this.patientDataProvider.activePatientData));
      this.patientDataProvider.activePatientData._rev = res.data.data.data.rev;
      this.formdata = new NoteData();
      this.editRow = false;
      
    }
  }

  async deleteConfirm(event) {
    const alert = await this.alertController.create({
      header: 'Warnung',
      message: 'Notiz wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            event.confirm.reject();
          }
        },
        {
          text: 'Löschen',
          handler: async () => {
              this.tableData.remove(event.data);
              this.patientDataProvider.activePatientData.notes = await this.tableData.getAll();

              this.formdata = new NoteData();
              this.editRow = false;

              this.patientDataProvider.update(this.patientDataProvider.activePatientData).subscribe((res:any)=>{
                this.patientDataProvider.activePatientData._rev = res.data.data.data.rev;
                this.tableData.refresh();
              });
          }
        }
      ]
    });
    alert.present();
  }
}
